// slice.ts
//
// (c) NCR Voyix Corporation 2025. All rights reserved.

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GlobalState } from './state'
import { sessionTimeoutPopupMinutesDefault } from '../../common/constants/timerConstants'
import { tablePageSizeDefault } from '../../common/constants/tablePageSizeConstants'
import { LOGOUT } from '../globalActions'

const initialState: GlobalState = {
  sessionTimeoutPopupMinutes: sessionTimeoutPopupMinutesDefault,
  tablePageSize: tablePageSizeDefault
}

export const globalSlice = createSlice({
  name: 'global',
  initialState,
  reducers: {
    setSessionTimeoutPopupMinutes: (state, action: PayloadAction<number | null>) => {
      state.sessionTimeoutPopupMinutes = action.payload ?? sessionTimeoutPopupMinutesDefault
    },
    setTablePageSize: (state, action: PayloadAction<number | null>) => {
      state.tablePageSize = action.payload ?? tablePageSizeDefault
    }
  },
  extraReducers: (builder) => {
    // Reset state on logout
    builder.addCase(LOGOUT, () => initialState)
  }
})

export default globalSlice.reducer
export const {
  setSessionTimeoutPopupMinutes,
  setTablePageSize
} = globalSlice.actions
